import { useSelector } from "react-redux";
import { StoreState } from "../interfaces/storeState";

export const useIsLoadedFromSummary = () => useSelector(getIsLoadedFromSummary);

const getIsLoadedFromSummary = (state: StoreState): boolean =>
  state.isLoadedFromSummary;
